import { useEffect } from 'react';
import { expireForInactivity, isIdle, recordGesture } from './session.js';

const GESTURES = ['pointerdown', 'keydown', 'wheel', 'touchstart'] as const;
/** How often inactivity is checked; the setting itself is counted in minutes. */
const IDLE_CHECK_INTERVAL_MS = 15_000;

/**
 * Counts the user's gestures and closes the session after the inactivity
 * setting (functional §9.2: thirty minutes by default, set by the central access).
 */
export function useSessionGuard(): void {
  useEffect(() => {
    const onGesture = () => recordGesture();
    GESTURES.forEach((name) => window.addEventListener(name, onGesture, { passive: true, capture: true }));
    const timer = window.setInterval(() => {
      if (isIdle()) void expireForInactivity();
    }, IDLE_CHECK_INTERVAL_MS);
    return () => {
      GESTURES.forEach((name) => window.removeEventListener(name, onGesture, { capture: true }));
      window.clearInterval(timer);
    };
  }, []);
}
